import { app_pathnames, app_route_keys } from "constants/urlPaths";
import { Badge } from "features/Common/modules/Badge/Badge";
import { whatsapp } from "features/Integration/constants/Integration.constants";
import React from "react";
import { useHistory } from "react-router-dom";
import classnames from "classnames";

export const WhatsappLinkingStatus = ({
  showLock,
  showLink,
  openWAModal,
  containerClassname = "",
}) => {
  const history = useHistory();

  if (showLock) {
    return (
      <div
        className={classnames(
          "tw-flex tw-justify-between tw-items-center tw-border-solid tw-border-[1.5px] tw-border-[#F7AD1E] tw-bg-[#FEEFD1] tw-px-3 tw-py-3 tw-rounded-[6px]",
          containerClassname
        )}
      >
        <div className="tw-text-[#7F5400] tw-font-[500] tw-text-[14px]">
          To connect personal number, you&apos;ll need to&nbsp;
          <span
            className="tw-text-[#0052CC] tw-underline tw-cursor-pointer"
            onClick={openWAModal}
          >
            buy whitelabeling
          </span>
          .
        </div>
        <Badge showBadge={true} />
      </div>
    );
  }

  if (showLink) {
    return (
      <div
        className={classnames(
          "tw-flex tw-justify-start tw-items-center tw-border-solid tw-border-[1.5px] tw-border-[#F7AD1E] tw-bg-[#FEEFD1] tw-px-3 tw-py-3 tw-rounded-[6px] tw-text-[#7F5400] tw-font-[500] tw-text-[14px]",
          containerClassname
        )}
      >
        To use your number for WhatsApp messages, please&nbsp;
        <span
          className="tw-text-[#0052CC] tw-underline tw-cursor-pointer"
          onClick={() => {
            history.push(
              app_pathnames[app_route_keys.integration_details]({
                slug: whatsapp,
              })
            );
          }}
        >
          connect your number
        </span>
        .
      </div>
    );
  }

  return <></>;
};
